import { useIsEditStore } from "@/stores/isEditStore";

export default {
  install(app) {
    app.config.globalProperties.$store = {
      isEditStore: useIsEditStore, // 注意：傳的是函式，不是呼叫結果
    };
  },
};
